export const isAdmin = () => {
  const conditionOne = localStorage.getItem(process.env.REACT_APP_ADMIN_KEY1) === process.env.REACT_APP_ADMIN_VALUE1;
  const conditionTwo = localStorage.getItem(process.env.REACT_APP_ADMIN_KEY2) === process.env.REACT_APP_ADMIN_VALUE2;
  const conditionThree = localStorage.getItem(process.env.REACT_APP_ADMIN_KEY3) === process.env.REACT_APP_ADMIN_VALUE3;

  return conditionOne && conditionTwo && conditionThree;
};
